export enum CenterToggle {
    All = 0,
    MemberCenters = 1,
    ProspectCenters = 2,
    DashCenters = 3,
    DcnCenters = 4,
    PartnerCenters = 5,
    AllInNonPartnerCenters = 6,
    MicrositeCenters = 7
}